import React, { useEffect, useState } from 'react'
import { NavLink, useHistory, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { Layout, Space, Spin } from 'antd'
import { getOperationsByKeys, isUserAllowed } from 'modules/core/utils'
import { useTranslation } from 'react-i18next'
import { AllComments } from './components'
import periodsMenu from './periodsMenu'
import planning from 'modules/planning'
import login from 'modules/login'
import configuration from 'modules/configuration'

import './SiderLayout.scss'
import BookmarkSide from './components/Bookmark'
import PropTypes from 'prop-types'

const { Content, Sider } = Layout

const SiderLayout = ({
  extraKey = null,
  match: {
    params: { periodId },
    path,
  },
  header = null,
  children,
  className,
  fetchPeriodList,
  periodList,
  loggedUser,
  showAllComments,
  fetchCommentsList,
  commentsList,
  listBookmarks,
  bookmarks,
  openBookmark,
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const [data, setData] = useState([])
  const { t } = useTranslation()
  const history = useHistory()

  const key = window.location.pathname.replaceAll('/', '-')

  useEffect(() => {
    if (loggedUser.society_id !== 0) {
      listBookmarks()
    }
  }, [listBookmarks, loggedUser])

  useEffect(() => {
    if (!periodId) {
      fetchPeriodList()
    }
  }, [fetchPeriodList, periodId])

  useEffect(() => {
    if (showAllComments) {
      setIsLoading(true)
      fetchCommentsList({ module: `${key}${extraKey || ''}` }).then((response) => {
        setIsLoading(false)
      })
    }
  }, [fetchCommentsList, key, showAllComments, extraKey])

  useEffect(() => {
    setData([...commentsList])
  }, [commentsList])

  const removeBy = (url) => {
    return url.replace(window.location.origin, '')
  }

  const handleClickUrl = (item) => {
    history.push(removeBy(item.url)) // Navega a la URL
  }

  return (
    <Layout className={`sider-layout ${className ? className : ''}`}>
      <Sider
        className="sider-layout-menu"
        collapsible
        collapsed={true}
        trigger={null}
        collapsedWidth={56}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            height: '100%',
            paddingBottom: 10,
          }}
        >
          <Space className="sub-layout-actions" align="center" direction="vertical" size="large">
            {periodsMenu(t)
              .filter((navItem) => isUserAllowed(getOperationsByKeys(navItem.allowedFor)))
              .map((item, index) => {
                const { title, url, exact, icon } = item
                return (
                  <NavLink
                    key={index}
                    className="menu-icon"
                    to={url.replace(':periodId', periodId || periodList[0]?.id)}
                    exact={exact}
                    activeClassName="selected"
                    title={title}
                  >
                    {icon}
                  </NavLink>
                )
              })}
          </Space>
        </div>
      </Sider>
      <Layout>
        {header}
        <Content className={`sider-layout-content ${className || ''}`}>{children}</Content>
        {showAllComments && (
          <Sider width={330} style={{ padding: 10 }}>
            <Spin spinning={isLoading}>
              <AllComments
                userDetail={loggedUser}
                comments={data}
                setData={setData}
                onRefetchComments={() => fetchCommentsList({ module: `${key}${extraKey || ''}` })}
              />
            </Spin>
          </Sider>
        )}
        {openBookmark && (
          <Sider width={330} style={{ padding: 10 }}>
            <BookmarkSide onClick={handleClickUrl} />
          </Sider>
        )}
      </Layout>
    </Layout>
  )
}

const mapStateToProps = (state) => ({
  periodList: planning.selectors.getPeriodList(state),
  loggedUser: login.selectors.getWhoAmI(state),
  showAllComments: configuration.selectors.getShowAllComments(state),
  commentsList: configuration.selectors.getCommentsList(state),
  bookmarks: configuration.selectors.getBookmarks(state),
  openBookmark: configuration.selectors.getOpenBookmarks(state),
})

const mapDispatchToProps = {
  fetchPeriodList: planning.actions.fetchPeriodList,
  fetchCommentsList: configuration.actions.fetchCommentsList,
  listBookmarks: configuration.actions.listBookmarks,
}

SiderLayout.propTypes = {
  extraKey: PropTypes.any,
  match: PropTypes.shape({
    path: PropTypes.string,
  }),
  periodList: PropTypes.array,
  loggedUser: PropTypes.shape({
    society_id: PropTypes.any,
  }),
  showAllComments: PropTypes.bool,
  fetchCommentsList: PropTypes.func,
  commentsList: PropTypes.array,
  listBookmarks: PropTypes.func,
  bookmarks: PropTypes.any,
  openBookmark: PropTypes.bool,
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SiderLayout))
